import PackageCompositionV1 from './PackageCompositionV1'
import APIService from '@/api/services/APIService/APIServiceImpl'
import { PackageCompositionResponseDTO } from '../../../../../requests-module'

import axios from 'axios'

export default class PackageCompositionV1Impl
    extends APIService
    implements PackageCompositionV1 {
    constructor() {
        // const serviceUrl = `https://api-migdal.travelfactory.fr/cms/package-composition` // TODO switch url
        const serviceUrl = window.env.VUE_APP_PACKAGE_COMPOSITION_URL || ''
        super(serviceUrl)
    }

    async getPackageComposition(
        liheId: string,
        startDate: string,
        endDate: string,
        packageId: string
    ): Promise<PackageCompositionResponseDTO> {
        try {
            const { data } = await axios.get(this.getServiceUrl(), {
                params: {
                    liheId,
                    startDate,
                    endDate,
                    prestId: packageId,
                },
            })
            return data
        } catch (error) {
            // Endpoint fails
            throw new Error(error)
        }
    }
}
